export function resolveMediaUrl(pathOrUrl) {
  const value = (pathOrUrl || "").trim();
  if (!value) {
    return "";
  }
  if (/^https?:\/\//i.test(value)) {
    return value;
  }
  if (value.startsWith("/")) {
    if (
      value.startsWith("/uploadimgs/") ||
      value.startsWith("/uploadvideos/") ||
      value.startsWith("/tempimgs/") ||
      value.startsWith("/mini-game-maps/")
    ) {
      return `/api${value}`;
    }
    return `${window.location.origin}${value}`;
  }
  return value;
}

export function handleDownloadVideo(videoUrl) {
  if (!videoUrl) {
    return;
  }
  const normalizedUrl = (videoUrl || "").trim();
  const marker = "/uploadvideos/";
  const markerIndex = normalizedUrl.indexOf(marker);
  if (markerIndex !== -1) {
    const filename = normalizedUrl.slice(markerIndex + marker.length);
    window.open(`/api/download/video/${encodeURIComponent(filename)}`, "_blank");
    return;
  }
  window.open(resolveMediaUrl(videoUrl), "_blank");
}
